import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const RunAReportIcon = ({ label = 'RunAReport', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M235.5 261.7V98.9l-68.6-68.7H72.6a8.2 8.2 0 0 0-8.5 7.9v223.6a8.3 8.3 0 0 0 7.9 8.6h154.9a8.2 8.2 0 0 0 8.6-7.9z" style="fill:#f4c223"/><path d="M72.3 30.2h94.6l68.6 68.7v163.4a8.2 8.2 0 0 1-8.2 7.9H72a8.3 8.3 0 0 1-7.9-8.6V38.1a8.2 8.2 0 0 1 8.2-7.9m0-10a18.2 18.2 0 0 0-18.2 17.5v223.8a18 18 0 0 0 4.8 12.9 17.6 17.6 0 0 0 12.7 5.8h155.7a18.2 18.2 0 0 0 18.2-17.5V98.9a9.9 9.9 0 0 0-2.9-7.1L174 23.2a10 10 0 0 0-7.1-3H72.3z" style="fill:#1d1d1b"/><path d="M204.9 158H94.7a5.1 5.1 0 0 1-5-5 5 5 0 0 1 5-5h110.2a5 5 0 0 1 5 5 5.1 5.1 0 0 1-5 5zm-31.7 54.8H94.7a5.1 5.1 0 0 1-5-5 5 5 0 0 1 5-5h78.5a5 5 0 0 1 5 5 5 5 0 0 1-5 5zm31.7-27.4H94.7a5.1 5.1 0 0 1-5-5 5 5 0 0 1 5-5h110.2a5 5 0 0 1 5 5 5.1 5.1 0 0 1-5 5z" style="fill:#1d1d1b"/><path style="fill:#fff" d="M170.8 27.2v67.7h67.7l-67.7-67.7z"/><path d="M238.5 99.9h-67.7a5 5 0 0 1-5-5V27.2a5 5 0 0 1 3.1-4.6 4.8 4.8 0 0 1 5.4 1.1l67.8 67.7a5 5 0 0 1-3.6 8.5zm-62.7-10h50.6l-50.6-50.6z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

RunAReportIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { RunAReportIcon }
